import { render, staticRenderFns } from "./InfoLocalisation.vue?vue&type=template&id=096f38b9&scoped=true&"
import script from "./InfoLocalisation.vue?vue&type=script&lang=js&"
export * from "./InfoLocalisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096f38b9",
  null
  
)

export default component.exports